<div *ngIf="SelectedCollege">
    <h2 class="mat-title">Course Request Optional Comment(s)</h2>
    <div>Note: The following table lists any optional notes or comments which have been entered in regards to this student's Dual Enrollment program at {{SelectedCollege.CollegeName}} for the {{SelectedCollege.Term.TermCode | collegeTerm}} {{SelectedCollege.Term.CollegeSchoolYear | collegeSchoolYear:SelectedCollege.CollegeID}} term:</div>

    <!-- Notes Table -->
    <mat-table class="bordered" #table [dataSource]="NotesDataSource">
        <ng-container matColumnDef="Date">
            <mat-header-cell *matHeaderCellDef class="centered">Date</mat-header-cell>
            <mat-cell *matCellDef="let note" class="centered"><span *ngIf="note.NoteDate">{{note.NoteDate | datefns:'M/DD/YYYY h:mm A'}}</span></mat-cell>
        </ng-container>

        <ng-container matColumnDef="Creator">
            <mat-header-cell *matHeaderCellDef class="centered">Creator</mat-header-cell>
            <mat-cell *matCellDef="let note" class="centered">
                <span *ngIf="note.NoteCreator != -1">{{note.LastName | titleCase}}, {{note.FirstName | titleCase}}</span>
                <span *ngIf="note.NoteCreator == -1">DELTA System</span>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Note">
            <mat-header-cell *matHeaderCellDef class="centered">Note</mat-header-cell>
            <mat-cell *matCellDef="let note" class="centered">
                <div class="fullwidth" [innerHTML]="note.Note | safeHTML"></div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef class="centered">Action(s)</mat-header-cell>
            <mat-cell *matCellDef="let note" class="centered">
                <button mat-raised-button color="warn" *ngIf="User && note.NoteCreator == User.UserID" (click)="RemoveNote(note)">Remove</button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="NoData">
            <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
            <mat-cell *matCellDef="let note"><em>No optional course request notes have been entered for this college term.</em></mat-cell>
        </ng-container>

        <ng-container matColumnDef="SmallDisplay">
            <mat-header-cell *matHeaderCellDef class="centered">Note(s)</mat-header-cell>
            <mat-cell *matCellDef="let note">
                <div fxLayout="column" fxLayoutAlign="start stretch">
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Date</form-label>
                        <span *ngIf="note.NoteDate">{{note.NoteDate | datefns:'M/DD/YYYY h:mm A'}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Creator</form-label>
                        <span>{{note.LastName | titleCase}}, {{note.FirstName | titleCase}}</span>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between start">
                        <form-label>Note</form-label>
                        <div [innerHTML]="note.Note | safeHTML"></div>
                    </div>
                    <div *ngIf="SelectedCollege && SelectedCollege.HistoricalRecord !== true" fxLayout="column" fxLayoutAlign="start center">
                        <button mat-raised-button color="warn" *ngIf="User && note.NoteCreator == User.UserID" (click)="RemoveNote(note)">Remove</button>
                    </div>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="VisibleHeaders"></mat-header-row>
        <mat-row *matRowDef="let row; columns: VisibleColumns; let $even = even" [class.primarybackground50]="$even"></mat-row>
    </mat-table>

    <!-- Action button(s) -->
    <div class="buttongroup" *ngIf="SelectedCollege.FormStatus >= 3 && SelectedCollege.HistoricalRecord !== true">
        <!-- Don't allow buttons by default if this has been submitted to college-->
        <button mat-raised-button color="primary" (click)="AddNote()">Add an optional note</button>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/ui/requestnotes/requestnotes.component.html